"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeService = exports.TimeUnits = void 0;
//import moment from "moment";
const moment_timezone_1 = __importDefault(require("moment-timezone"));
var TimeUnits;
(function (TimeUnits) {
    TimeUnits["MILLISECONDS"] = "milliseconds";
    TimeUnits["SECONDS"] = "seconds";
    TimeUnits["MINUTES"] = "minutes";
    TimeUnits["HOURS"] = "hours";
    TimeUnits["DAYS"] = "days";
    TimeUnits["WEEKS"] = "weeks";
    TimeUnits["MONTHS"] = "months";
    TimeUnits["QUARTERS"] = "quarters";
    TimeUnits["YEARS"] = "years";
})(TimeUnits || (TimeUnits = {}));
exports.TimeUnits = TimeUnits;
class TimeService {
    // ============================= Time Constants ================================
    static ONE_SECOND_MILLIS = 1000;
    static ONE_MINUTE_MILLIS = 60 * TimeService.ONE_SECOND_MILLIS;
    static FIVE_MINUTE_MILLIS = 5 * TimeService.ONE_MINUTE_MILLIS;
    static HALF_HOUR_MILLIS = 30 * TimeService.ONE_MINUTE_MILLIS;
    static ONE_HOUR_MILLIS = 60 * TimeService.ONE_MINUTE_MILLIS;
    static TWELVE_HOUR_MILLIS = 12 * TimeService.ONE_HOUR_MILLIS;
    static ONE_DAY_MILLIS = 24 * TimeService.ONE_HOUR_MILLIS;
    // =============================================================================
    // User Input: '2024-02-21', '15:00', 'America/Denver'
    static createDateTime(dateString, timeString, timezone) {
        return moment_timezone_1.default.tz(`${dateString} ${timeString}`, timezone).format();
        // Example: createDateTime('2024-02-21', '15:00', 'America/Denver');
    }
    /*public static addHoursToDateTimeISO8601( hours: number, dateTimeISO8601: string | undefined, timezone: string | undefined ) {
      if( !dateTimeISO8601 || !timezone ) {
        dateTimeISO8601 =  momentTimezone().toISOString();
        //timezone = "UTC"; // Default ... ?? -- If null, then it'd be defaulted to local Timezone?? (but what is local)? -- TEST
      }
  
      const momentDateTime = momentTimezone.tz( dateTimeISO8601, timezone );
      const newDateTime = momentDateTime.add( hours, "hours" ).format();
  
      return newDateTime;
    }*/
    static addUnitsToDateTimeISO8601(amount, unit, dateTimeISO8601, timezone = moment_timezone_1.default.tz.guess()) {
        if (!dateTimeISO8601) {
            dateTimeISO8601 = (0, moment_timezone_1.default)().toISOString();
            //timezone = "UTC"; // Default ... ?? -- If null, then it'd be defaulted to local Timezone?? (but what is local)? -- TEST
        }
        const momentDateTime = moment_timezone_1.default.tz(dateTimeISO8601, timezone);
        const newDateTime = momentDateTime.add(amount, unit).format();
        return newDateTime;
    }
    // TODO: This is a non-meaningful name...
    static convertDateTimeStringToFormattedString(dateTimeString, timezone = moment_timezone_1.default.tz.guess()) {
        const momentDate = moment_timezone_1.default.tz(dateTimeString, timezone);
        // Extract the various components
        const dayOfWeek = momentDate.format("dddd");
        const datePart = momentDate.format("M/D/YYYY");
        const timePart = momentDate.format("h:mm A");
        const timezoneAbbreviation = momentDate.format('z'); // Get the timezone abbreviation (e.g., MST or MDT)
        return `${dayOfWeek} ${datePart} - ${timePart} ${timezoneAbbreviation}`;
    }
    static convertDateTimeStringToDateTimeHTMLPicker(dateTimeISO8601String, timezone = moment_timezone_1.default.tz.guess()) {
        //const parsedDateTime = momentTimezone( dateTimeISO8601String, "YYYYMMDDTHHmmssZ" );
        //const formattedDateTime = parsedDateTime.tz(timezone).format( "YYYY-MM-DDTHH:mm" );
        const parsedDateTime = (0, moment_timezone_1.default)(dateTimeISO8601String);
        const formattedDateTime = parsedDateTime.tz(timezone).format("YYYY-MM-DDTHH:mm");
        return formattedDateTime;
    }
    static convertDateTimeHTMLPickerToDateTimeString(dateTimeHTMLPickerString, timezone = moment_timezone_1.default.tz.guess()) {
        const localDateTime = moment_timezone_1.default.tz(dateTimeHTMLPickerString, timezone);
        const dateTimeISO8601String = localDateTime.utc().toISOString();
        return dateTimeISO8601String;
    }
    static getTimezoneAbbreviation(dateTimeISO8601String, timezone = moment_timezone_1.default.tz.guess()) {
        const momentDateTime = moment_timezone_1.default.tz(dateTimeISO8601String, timezone);
        const timezoneAbbreviation = momentDateTime.tz(timezone).format("z");
        return timezoneAbbreviation;
    }
    static getMinutesAgoFromCheckpointDate(checkpointDateEpoch, referenceDateEpoch = Date.now()) {
        let minutesAgo = 5; // DEFAULT - TODO: Decide if want keep, change, or remove ...?
        if (checkpointDateEpoch) {
            minutesAgo = (referenceDateEpoch - checkpointDateEpoch) / 1000 / 60;
        }
        return minutesAgo;
    }
    static getTimestampFromMinutesAgo(minutesAgo, referenceDateEpoch = Date.now()) {
        const timestampMin = new Date(referenceDateEpoch - 1000 * 60 * Number(minutesAgo)).toISOString();
        return timestampMin;
    }
    static getMonthNameFromNumber(monthNumber) {
        const formattedMonthNumber = String(monthNumber).padStart(2, "0");
        // Create a (mock) Date in desired month and use that to get only month name
        return (0, moment_timezone_1.default)(`2024-${formattedMonthNumber}-01`).format("MMMM");
    }
    // TODO: Seems this is a DateTimeISO8601 (at least as used in Coaching Component) -- Consider renaming to "FromDateTime" and input "dateTimeString" (maybe ISO8601)
    static getDayOfWeekFromDate(dateString) {
        if (!dateString)
            return "NoDay";
        return (0, moment_timezone_1.default)(dateString).format("dddd"); // E.g. "Monday"
    }
    static getDayOfMonthOrdinalWithSuffix(dayOfMonth) {
        const dayNumber = typeof dayOfMonth === "string" ? parseInt(dayOfMonth, 10) : dayOfMonth;
        let suffix = "th";
        if (dayNumber % 100 < 11 || dayNumber % 100 > 13) {
            switch (dayNumber % 10) {
                case 1:
                    suffix = "st";
                    break;
                case 2:
                    suffix = "nd";
                    break;
                case 3:
                    suffix = "rd";
                    break;
            }
        }
        return dayOfMonth + suffix;
    }
    static convertTime24To12HourFormat(time24) {
        const [hours, minutes] = time24.split(":").map(num => parseInt(num, 10));
        const period = hours >= 12 ? "PM" : "AM";
        const hours12 = hours % 12 || 12; // If already 12th hour, keep it, i.e. if % = 0
        const zeroBasedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${hours12}:${zeroBasedMinutes} ${period}`;
    }
    static extractDateTimeISO8601Components(dateTimeISO8601String) {
        if (!dateTimeISO8601String) {
            return {
                yearNumber: 0, monthNumber: 0, dayNumber: 0,
                time24: "00:00", timezoneOffset: "Z"
            };
        }
        const [dateComponent, timeComponentWithOffset] = dateTimeISO8601String.split("T");
        const [yearNumber, monthNumber, dayNumber] = dateComponent.split("-").map(Number);
        let time24, timezoneOffset;
        if (timeComponentWithOffset.endsWith("Z")) { // UTC
            time24 = timeComponentWithOffset.replace("Z", "");
            timezoneOffset = "Z";
        }
        else {
            const timeComponentSplit = timeComponentWithOffset.split(/[\+\-]/);
            time24 = timeComponentSplit[0];
            const sign = timeComponentWithOffset.includes("+") ? "+" : "-";
            timezoneOffset = sign + timeComponentSplit[1];
        }
        return {
            yearNumber, monthNumber, dayNumber,
            time24, timezoneOffset
        };
    }
}
exports.TimeService = TimeService;
